export const SpiritualValues = [
    {
        name: 'Goodness',
        description: `Have a fully funded emergency fund, save for retirement`
    },
    {
        name: 'Truth',
        description: `achieve financial independence ASAP by cutting living expenses and increasing income/savings rate`
    },
    {
        name: 'Beauty',
        description: `save monthly for one big trip per year`
    },
    {
        name: 'Peace',
        description: `save a down payment, improve credit score`
    },
    {
        name: 'Love',
        description: `live on one income so one parent can be at home full-time`,
    },
    {
        name: 'Non-violence',
        description: `pay for a gym membership and healthy food by cutting expenses in other areas`
    },
    {
        name: 'Righteousness',
        description: `Give a certain amount of money each month to an organization`,
    },
]